import { styled, keyframes, css } from "../../styles";
import { preLoginPrimaryButtonVars } from "../../styles/preLoginBranding";

const spin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

export const MainContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100dvh",
  backgroundColor: "$gray-5",
  padding: "20px",
  fontFamily: "$openSans",
  boxSizing: "border-box",

  "@sm": {
    padding: "16px",
  },
});

export const Card = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  backgroundColor: "white",
  borderRadius: "12px",
  padding: "40px 48px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  maxWidth: "560px",
  width: "100%",
  boxSizing: "border-box",

  variants: {
    centered: {
      true: {
        alignItems: "center",
        textAlign: "center",
        maxWidth: "440px",
      },
    },
  },

  "@sm": {
    padding: "32px 24px",
  },
});

export const Logo = styled("img", {
  width: "180px",
  marginBottom: "28px",
  alignSelf: "center",

  "@sm": {
    width: "150px",
    marginBottom: "24px",
  },
});

export const IconContainer = styled("div", {
  width: "72px",
  height: "72px",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "24px",

  variants: {
    status: {
      loading: { backgroundColor: "$primary-5" },
      success: { backgroundColor: "$success-lightest" },
      error: { backgroundColor: "$error-lightest" },
    },
  },
});

export const Spinner = styled("div", {
  width: "36px",
  height: "36px",
  border: "3px solid $primary-10",
  borderTop: "3px solid $primary-40",
  borderRadius: "50%",
  animation: `${spin} 1s linear infinite`,
});

export const Title = styled("h1", {
  color: "$gray-100",
  margin: "0 0 12px",
  fontSize: "22px",
  fontWeight: "600",
  lineHeight: "30px",
});

/** Heading of the "Optional details" block inside the form. */
export const SectionTitle = styled("h2", {
  color: "$gray-100",
  margin: "8px 0 4px",
  fontSize: "17px",
  fontWeight: "600",
  lineHeight: "24px",
});

export const Message = styled("p", {
  color: "$gray-60",
  fontSize: "15px",
  lineHeight: "22px",
  margin: "0 0 16px",
});

export const InfoText = styled("p", {
  color: "$gray-40",
  fontSize: "13px",
  lineHeight: "18px",
  margin: "8px 0 0",
});

/** The read-only facts TMP already sent, above the form. */
export const SummaryBlock = styled("dl", {
  display: "grid",
  gridTemplateColumns: "minmax(120px, auto) 1fr",
  columnGap: "16px",
  rowGap: "8px",
  margin: "0 0 24px",
  padding: "16px",
  borderRadius: "8px",
  backgroundColor: "$gray-20",
  fontSize: "14px",
  lineHeight: "20px",

  "& dt": {
    color: "$gray-80",
    margin: 0,
  },
  "& dd": {
    color: "$gray-100",
    fontWeight: "600",
    margin: 0,
    wordBreak: "break-word",
  },
});

export const Form = styled("form", {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
});

export const FieldGroup = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
});

export const FieldLabel = styled("label", {
  fontSize: "14px",
  fontWeight: "600",
  lineHeight: "20px",
  color: "$gray-100",
});

export const RadioRow = styled("div", {
  display: "flex",
  gap: "24px",
  flexWrap: "wrap",
});

export const RadioOption = styled("label", {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "14px",
  color: "$gray-100",
  cursor: "pointer",

  "& input": {
    width: "18px",
    height: "18px",
    margin: 0,
    accentColor: "$primary",
    cursor: "pointer",
  },
});

export const FieldError = styled("span", {
  fontSize: "13px",
  lineHeight: "18px",
  color: "$error-light",
  fontWeight: "600",
});

export const FormError = styled("p", {
  margin: 0,
  padding: "12px",
  borderRadius: "6px",
  backgroundColor: "$error-lightest",
  color: "$error-dark",
  fontSize: "13px",
  lineHeight: "18px",
  whiteSpace: "pre-wrap",
});

export const submitButtonStyles = css({
  ...preLoginPrimaryButtonVars,
  marginTop: "8px",
});
